import {
  IconAlertCircle,
  IconAlertOctagon,
  IconAlertTriangle,
  IconInfoCircle,
  IconShield,
  IconShieldCheck,
} from "@tabler/icons-react";
import { useLingui } from "@lingui/react";
import type { MessageDescriptor } from "@lingui/core";
import type { ReactNode } from "react";

import { cx } from "./cx";
import { Tooltip } from "./Tooltip";
import styles from "./RiskBadge.module.css";

export type RiskTone = "low" | "medium" | "high" | "critical" | "info" | "secure";

const ICON_SIZE = 14;

const toneIcon: Record<RiskTone, typeof IconShield> = {
  low: IconShield,
  medium: IconAlertTriangle,
  high: IconAlertCircle,
  critical: IconAlertOctagon,
  info: IconInfoCircle,
  secure: IconShieldCheck,
};

export interface RiskBadgeProps {
  tone: RiskTone;
  label: MessageDescriptor | string;
  selected?: boolean;
  className?: string;
  tooltip?: ReactNode;
  tooltipTabIndex?: number;
}

export function RiskBadge({ tone, label, selected = false, className, tooltip, tooltipTabIndex }: RiskBadgeProps): JSX.Element {
  const { i18n } = useLingui();
  const Icon = toneIcon[tone];
  const text = typeof label === "string" ? label : i18n._(label);
  const badge = (
    <span className={cx(styles.badge, styles[tone], selected && styles.selected, className)}>
      <Icon size={ICON_SIZE} aria-hidden="true" />
      {text}
    </span>
  );
  if (tooltip != null) {
    return <Tooltip content={tooltip} tabIndex={tooltipTabIndex}>{badge}</Tooltip>;
  }
  return badge;
}
